import React, { useState, useEffect } from "react";
import { Card, Alert, Row, Col, Nav, Form, Container } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import logo from "../assets/mboxLogo.jpeg";
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaShip,
  FaPlane,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaMapMarkerAlt,
  FaWeight,
  FaRuler,
} from "react-icons/fa";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";

const API_HOST = process.env.REACT_APP_API_URL;
const API = process.env.REACT_APP_API_KEY;

// Solución para los iconos de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const FormularioCliente = () => {
  const cookies = new Cookies();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [activeSection, setActiveSection] = useState("formulario");
  const [pais, setPais] = useState("US");
  const [validated, setValidated] = useState(false);

  const [tipoEnvio, setTipoEnvio] = useState("maritimo");
  const [peso, setPeso] = useState(0);
  const [pesoVolumetrico, setPesoVolumetrico] = useState(0);
  const [dimensiones, setDimensiones] = useState({
    largo: 0,
    ancho: 0,
    alto: 0,
  });
  const [pesoVolumetricoIngresado, setPesoVolumetricoIngresado] = useState(0);

  const [tipoCalculo, setTipoCalculo] = useState("real");
  const [tiposClientes, setTiposClientes] = useState([]);
  const [tipoCambio, setTipoCambio] = useState();
  const [total, setTotal] = useState(0);

  const gastoManejoUSD = pais === "US" ? 4.7 : 5.0;

  const [formData, setFormData] = useState({
    nombre: "",
    identidad: "",
    telefono: "",
    email: "",
    fechaNacimiento: "",
    idTipoCliente: 1,
    direccion: "",
    terminosAceptados: false,
  });

  const [errors, setErrors] = useState({
    telefono: "",
  });

  const position = [14.083986, -87.1855946];

  const styles = {
    background: {
      background: "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)",
      minHeight: "100vh",
      padding: "2rem 0",
    },
    card: {
      border: "none",
      borderRadius: "15px",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
      overflow: "hidden",
      width: "100%",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      height: "100%",
    },
    cardHeader: {
      background: "#3a5a8a",
      color: "white",
      padding: "1.5rem",
      marginBottom: "1.5rem",
      borderBottom: "3px solid #2c4365",
    },
    navPills: {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      borderRadius: "50px",
      padding: "0.5rem",
      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
      maxWidth: "fit-content",
      margin: "0 auto",
    },
    navLink: {
      borderRadius: "50px",
      padding: "0.5rem 1.5rem",
      fontWeight: "600",
      color: "#4b6cb7",
      margin: "0 0.25rem",
    },
    navLinkActive: {
      background: "#3a5a8a",
      color: "white",
    },
    mapContainer: {
      height: "200px",
      borderRadius: "10px",
      overflow: "hidden",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
      marginTop: "1rem",
    },
    dimensionInput: {
      width: "100%",
      marginBottom: "0.5rem",
    },
    calculatorButton: {
      border: "2px solid #3a5a8a",
      color: "#3a5a8a",
      fontWeight: "600",
      backgroundColor: "white",
    },
    calculatorButtonActive: {
      background: "#3a5a8a",
      color: "white",
      border: "2px solid #3a5a8a",
      fontWeight: "600",
    },
    infoBox: {
      backgroundColor: "#f8f9fa",
      borderRadius: "10px",
      padding: "1rem",
      marginBottom: "1.5rem",
    },
    contactInfoItem: {
      marginBottom: "1.5rem",
    },
    whatsappButton: {
      backgroundColor: "#25D366",
      color: "white",
      fontWeight: "600",
      padding: "1rem",
      borderRadius: "10px",
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      marginTop: "1rem",
      transition: "all 0.3s ease",
    },
    statusCard: {
      borderLeft: "4px solid",
      padding: "1.5rem",
      marginBottom: "1rem",
      borderRadius: "8px",
      backgroundColor: "white",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      transition: "all 0.3s ease",
    },
    statusIcon: {
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "1rem",
      animation: "pulse 2s infinite",
    },
    progressBar: {
      height: "6px",
      borderRadius: "3px",
      backgroundColor: "#e9ecef",
      margin: "2rem 0",
      overflow: "hidden",
    },
    progressStep: {
      height: "100%",
      transition: "width 0.6s ease",
    },
  };

  // Agregar animaciones CSS
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.1); }
        100% { transform: scale(1); }
      }
      @keyframes bounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
      }
      .status-active {
        animation: bounce 1s ease infinite;
      }
      .status-card:hover {
        transform: translateY(-5px);
        boxShadow: 0 6px 16px rgba(0,0,0,0.15);
      }
    `;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "telefono") {
      // Explicación del Regex:
      // ^\d{4}-\d{4}$ -> Formato HN
      // | -> O
      // ^\d{3}-\d{3}-\d{4}$ -> Formato USA/MX
      const phoneRegex = /^(\d{4}-\d{4}|\d{3}-\d{3}-\d{4})$/;
      let errorMsg = "";

      if (value && !phoneRegex.test(value)) {
        // Verificamos el largo para dar un error más preciso
        const digits = value.replace(/\D/g, "");
        if (digits.length > 8) {
          errorMsg = "Formato USA/MX incorrecto: ###-###-####";
        } else {
          errorMsg = "Formato HN incorrecto: ####-####";
        }
      }

      setErrors({
        ...errors,
        [name]: errorMsg,
      });
    }

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let errorMsg = "";

      if (value && !emailRegex.test(value)) {
        errorMsg = "Por favor ingrese un correo válido (ejemplo@dominio.com)";
      }

      setErrors({
        ...errors,
        [name]: errorMsg,
      });
    }

    if (name === "identidad") {
      const identityRegex = /^\d{4}-\d{4}-\d{5}$/;
      let errorMsg = "";

      if (value && !identityRegex.test(value)) {
        errorMsg = "Formato incorrecto. Use ####-####-#####";
      }

      setErrors({
        ...errors,
        [name]: errorMsg,
      });
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() === false || !formData.terminosAceptados) {
      setValidated(true);
      if (!formData.terminosAceptados) {
        Swal.fire(
          "Atención",
          "Debes aceptar los términos y condiciones.",
          "warning",
        );
      }
      return;
    }

    const dataToSend = { ...formData };
    delete dataToSend.terminosAceptados;

    try {
      const response = await fetch(`${API_HOST}/clientes/public`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          API: API,
        },
        body: JSON.stringify(dataToSend),
      });

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 409) {
          throw new Error(
            "Ya existe un cliente registrado con esta identidad o correo electrónico. Ponte en contacto con nosotros para brindarte más información.",
          );
        }
        throw new Error(data.message || "Error al registrar el cliente");
      }

      Swal.fire("Éxito", "Casillero creado correctamente", "success");

      setFormData({
        nombre: "",
        identidad: "",
        telefono: "",
        email: "",
        fechaNacimiento: "",
        idTipoCliente: 1,
        direccion: "",
        terminosAceptados: false,
      });

      setValidated(false);
      setShowSuccess(true);
      setShowError(false);
    } catch (error) {
      if (error.message.includes("Ya existe un cliente")) {
        Swal.fire({
          title: "Cliente Existente",
          text: error.message,
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
      } else {
        Swal.fire(
          "Error",
          error.message || "Hubo un problema al crear el casillero",
          "error",
        );
      }
      setShowError(true);
      setShowSuccess(false);
    }
  };

  const calcularPesoVolumetrico = () => {
    const { largo, ancho, alto } = dimensiones;
    const resultado = (largo * ancho * alto) / 166;
    setPesoVolumetrico(resultado.toFixed(2));

    return resultado;
  };

  const calcularTotal = () => {
    const pesoVol = parseFloat(calcularPesoVolumetrico());
    const pesoVolumetricoVal = parseFloat(pesoVolumetricoIngresado);

    let pesoFinal =
      tipoCalculo === "real" ? peso : Math.max(pesoVol, pesoVolumetricoVal);

    if (tipoEnvio === "maritimo" && pesoFinal < 20) {
      Swal.fire({
        title: "Peso insuficiente",
        text: "El peso mínimo para envío marítimo es de 20 libras",
        icon: "warning",
        confirmButtonColor: "#3a5a8a",
        confirmButtonText: "Entendido",
        customClass: {
          popup: "border-radius-15",
          confirmButton: "shadow-none",
        },
      });
      return;
    }
    let costoPorLibra =
      tipoEnvio === "maritimo" ? 3.0 : pais === "MX" ? 8.7 : 4.7;
    let resultado = pesoFinal * costoPorLibra + gastoManejoUSD;
    setTotal(resultado.toFixed(2));
  };

  const handleContactoSubmit = (e) => {
    e.preventDefault();
    window.open("https://wa.me/50498744314", "_blank");
  };

  useEffect(() => {
    fetchData();
    fetchTiposClientes();
  }, []);

  const handleFormattedInputChange = (e) => {
    let { name, value } = e.target;

    // Eliminar todo lo que no sea número ni guiones
    value = value.replace(/-/g, "").replace(/\D/g, "");

    let formattedValue = "";

    if (value.length <= 4) {
      // Si es hasta el cuarto dígito, solo lo mostramos
      formattedValue = value;
    } else if (value.length <= 8) {
      // Al ingresar el quinto dígito, ya debe aparecer el guion
      formattedValue = value.slice(0, 4) + "-" + value.slice(4);
    } else {
      // Al ingresar el noveno dígito, ya debe aparecer el segundo guion
      formattedValue =
        value.slice(0, 4) + "-" + value.slice(4, 8) + "-" + value.slice(8, 13);
    }

    // Limitar longitud máxima: 13 números = 15 caracteres con guiones
    if (formattedValue.length > 15) {
      formattedValue = formattedValue.slice(0, 15);
    }

    setFormData({
      ...formData,
      [name]: formattedValue,
    });
  };

  const handlePhoneFormattedChange = (e) => {
    let { name, value } = e.target;

    // 1. Limpiar: Solo dejamos números
    let cleanValue = value.replace(/\D/g, "");

    // 2. Limitar: Ahora permitimos hasta 10 dígitos (USA/MX)
    cleanValue = cleanValue.slice(0, 10);

    let formattedValue = "";

    if (cleanValue.length <= 8) {
      // FORMATO HONDURAS: ####-#### (o menos)
      if (cleanValue.length <= 4) {
        formattedValue = cleanValue;
      } else {
        formattedValue = cleanValue.slice(0, 4) + "-" + cleanValue.slice(4);
      }
    } else {
      // FORMATO USA/MEXICO: ###-###-####
      // Al pasar de 8 dígitos, re-formateamos con el estándar internacional
      formattedValue =
        cleanValue.slice(0, 3) +
        "-" +
        cleanValue.slice(3, 6) +
        "-" +
        cleanValue.slice(6);
    }

    setFormData({
      ...formData,
      [name]: formattedValue,
    });
  };
  const fetchTiposClientes = async () => {
    try {
      const response = await fetch(`${API_HOST}/tipoClientes/clientes`, {
        method: "GET",
        headers: {
          API: API,
        },
      });
      const result = await response.json();
      setTiposClientes(result);
    } catch (error) {
      console.error("Error fetching tipos clientes:", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_HOST}/tasaCambio/clientes`, {
        method: "GET",
        headers: {
          API: API,
        },
      });
      const result = await response.json();
      if (result.length > 0) {
        setTipoCambio(result[result.length - 1].tasa);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const renderCalculadora = () => (
    <Card style={styles.card}>
      <div style={styles.cardHeader}>
        <h3 className='text-center mb-0'>Calculadora de Envíos</h3>
      </div>

      <div className='d-flex justify-content-center mb-4 gap-3'>
        <Button
          onClick={() => setPais("US")}
          style={
            pais === "US"
              ? styles.calculatorButtonActive
              : styles.calculatorButton
          }
          className='d-flex align-items-center justify-content-center gap-2 px-4'
        >
          <img
            src='https://flagcdn.com/us.svg'
            alt='USA Flag'
            width='24'
            height='16'
            style={{ borderRadius: "2px" }}
          />
          <span>EE. UU.</span>
        </Button>
        <Button
          onClick={() => {
            setPais("MX");
            setTipoEnvio("aereo");
          }}
          style={
            pais === "MX"
              ? styles.calculatorButtonActive
              : styles.calculatorButton
          }
          className='d-flex align-items-center justify-content-center gap-2 px-4'
        >
          <img
            src='https://flagcdn.com/mx.svg'
            alt='Mexico Flag'
            width='24'
            height='16'
            style={{ borderRadius: "2px" }}
          />
          <span>México</span>
        </Button>
      </div>

      <Card.Body className='p-4'>
        <Form>
          <Row className='mb-4'>
            <Col md={6}>
              <Form.Group>
                <Form.Label className='fw-bold'>Tipo de envío</Form.Label>
                <div className='d-flex flex-column gap-2'>
                  <Button
                    style={
                      tipoEnvio === "maritimo"
                        ? styles.calculatorButtonActive
                        : styles.calculatorButton
                    }
                    onClick={() =>
                      pais === "US"
                        ? setTipoEnvio("maritimo")
                        : setTipoEnvio("aereo")
                    }
                    className='d-flex align-items-center justify-content-center gap-2'
                  >
                    <FaShip size={20} />
                    <span>Marítimo</span>
                  </Button>
                  <Button
                    style={
                      tipoEnvio === "aereo"
                        ? styles.calculatorButtonActive
                        : styles.calculatorButton
                    }
                    onClick={() => setTipoEnvio("aereo")}
                    className='d-flex align-items-center justify-content-center gap-2'
                  >
                    <FaPlane size={20} />
                    <span>Aéreo</span>
                  </Button>
                </div>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className='fw-bold'>Tipo de cálculo</Form.Label>
                <div className='d-flex flex-column gap-2'>
                  <Button
                    style={
                      tipoCalculo === "real"
                        ? styles.calculatorButtonActive
                        : styles.calculatorButton
                    }
                    onClick={() => setTipoCalculo("real")}
                    className='d-flex align-items-center justify-content-center gap-2'
                  >
                    <FaWeight size={20} />
                    <span>Peso</span>
                  </Button>
                  <Button
                    style={
                      tipoCalculo === "volumetrico"
                        ? styles.calculatorButtonActive
                        : styles.calculatorButton
                    }
                    onClick={() => setTipoCalculo("volumetrico")}
                    className='d-flex align-items-center justify-content-center gap-2'
                  >
                    <FaRuler size={20} />
                    <span>Peso volumétrico</span>
                  </Button>
                </div>
              </Form.Group>
            </Col>
          </Row>

          {tipoCalculo === "real" ? (
            <Form.Group className='mb-4'>
              <Form.Label className='fw-bold'>Peso (en libras)</Form.Label>
              <Form.Control
                type='number'
                min={tipoEnvio === "maritimo" ? "30" : "0"}
                step='0.1'
                value={peso}
                onChange={(e) => setPeso(parseFloat(e.target.value))}
                placeholder={`Ingrese el peso${
                  tipoEnvio === "maritimo" ? " (mínimo 20 libras)" : ""
                }`}
                className='py-2'
              />
            </Form.Group>
          ) : (
            <div className='mb-4'>
              <Form.Label className='fw-bold'>
                Dimensiones (en pulgadas)
              </Form.Label>
              <Row className='g-3'>
                <Col md={4}>
                  <Form.Control
                    type='number'
                    min='0'
                    step='0.1'
                    placeholder='Largo'
                    value={dimensiones.largo}
                    onChange={(e) =>
                      setDimensiones({
                        ...dimensiones,
                        largo: parseFloat(e.target.value),
                      })
                    }
                    className='py-2'
                    style={styles.dimensionInput}
                  />
                </Col>
                <Col md={4}>
                  <Form.Control
                    type='number'
                    min='0'
                    step='0.1'
                    placeholder='Ancho'
                    value={dimensiones.ancho}
                    onChange={(e) =>
                      setDimensiones({
                        ...dimensiones,
                        ancho: parseFloat(e.target.value),
                      })
                    }
                    className='py-2'
                    style={styles.dimensionInput}
                  />
                </Col>
                <Col md={4}>
                  <Form.Control
                    type='number'
                    min='0'
                    step='0.1'
                    placeholder='Alto'
                    value={dimensiones.alto}
                    onChange={(e) =>
                      setDimensiones({
                        ...dimensiones,
                        alto: parseFloat(e.target.value),
                      })
                    }
                    className='py-2'
                    style={styles.dimensionInput}
                  />
                </Col>
              </Row>

              <div className='mb-4'>
                <Form.Label className='fw-bold'>Peso (en libras)</Form.Label>

                <Col md={4}>
                  <Form.Control
                    type='number'
                    min='0'
                    step='0.1'
                    placeholder='Peso (en libras)'
                    value={pesoVolumetricoIngresado}
                    onChange={(e) =>
                      setPesoVolumetricoIngresado(e.target.value)
                    }
                    className='py-2'
                    style={styles.dimensionInput}
                  />
                </Col>
              </div>
              {pesoVolumetrico > 0 && (
                <div className='mt-3 text-center'>
                  <p className='mb-0'>
                    Peso volumétrico calculado:{" "}
                    <strong>{pesoVolumetrico} libras</strong>
                  </p>
                  <small className='text-muted'>
                    (Largo × Ancho × Alto) / 166
                  </small>
                  <p className='mb-0'>
                    El costo de envío se calcula considerando el mayor valor
                    entre el peso ingresado y el peso volumétrico calculado. En
                    este caso corresponde a:
                    <strong>
                      {` ${Math.max(
                        parseFloat(pesoVolumetrico),
                        parseFloat(pesoVolumetricoIngresado),
                      )} libras`}
                    </strong>
                  </p>
                </div>
              )}
            </div>
          )}

          <div style={styles.infoBox}>
            <p className='mb-2'>
              <strong>Gasto de manejo:</strong> $
              {parseFloat(gastoManejoUSD).toFixed(2)} (USD)
            </p>
            <p className='mb-0'>
              <strong>Costo por libra:</strong> $
              {tipoEnvio === "maritimo"
                ? parseFloat(3.0).toFixed(2)
                : pais === "MX"
                  ? parseFloat(8.7).toFixed(2)
                  : parseFloat(4.7).toFixed(2)}{" "}
              (USD)
            </p>
          </div>

          <div className='text-center mb-3'>
            <Button
              variant='primary'
              size='lg'
              onClick={calcularTotal}
              className='px-5 fw-bold'
            >
              Calcular Total
            </Button>
          </div>

          {total > 0 && (
            <div
              className='text-center p-3'
              style={{ backgroundColor: "#e9f5ff", borderRadius: "10px" }}
            >
              <h4 className='mb-2'>Total a pagar</h4>
              <h4 className='mb-0'>
                <strong>L {(total * tipoCambio).toFixed(2)}</strong> (LPS)
              </h4>
              <p className='text-muted mt-2 mb-0'>
                <small>
                  * Este monto es solo una estimación de referencia y puede
                  variar según las condiciones reales del envío. * No incluye
                  ISV.
                </small>
              </p>
            </div>
          )}
        </Form>
      </Card.Body>
    </Card>
  );

  const renderContacto = () => (
    <Container>
      <Row className='g-4 justify-content-center'>
        <Col lg={6}>
          <Card style={styles.card}>
            <div style={styles.cardHeader}>
              <h3 className='mb-0'>Información de Contacto</h3>
            </div>
            <Card.Body className='p-4'>
              <div style={styles.contactInfoItem}>
                <div className='d-flex align-items-start'>
                  <div className='me-3 mt-1'>
                    <FaPhone color='#3a5a8a' size={20} />
                  </div>
                  <div>
                    <h5 className='mb-1 fw-bold'>Teléfono / Whatsapp</h5>
                    <p className='mb-0'>(504) 9874-4314</p>
                  </div>
                </div>
              </div>

              <div style={styles.contactInfoItem}>
                <div className='d-flex align-items-start'>
                  <div className='me-3 mt-1'>
                    <FaEnvelope color='#3a5a8a' size={20} />
                  </div>
                  <div>
                    <h5 className='mb-1 fw-bold'>Correo electrónico</h5>
                    <p className='mb-0'>contacto@mboxhn.com</p>
                  </div>
                </div>
              </div>

              <div style={styles.contactInfoItem}>
                <div className='d-flex align-items-start'>
                  <div className='me-3 mt-1'>
                    <FaClock color='#3a5a8a' size={20} />
                  </div>
                  <div>
                    <h5 className='mb-1 fw-bold'>Horario</h5>
                    <p className='mb-0'>Lunes a viernes 08:00 am - 05:00 pm</p>
                    <p className='mb-0'>Sábados 09:00 am - 12:00 pm</p>
                  </div>
                </div>
              </div>

              <div style={styles.contactInfoItem}>
                <div className='d-flex align-items-start'>
                  <div className='me-3 mt-1'>
                    <FaMapMarkerAlt color='#3a5a8a' size={20} />
                  </div>
                  <div>
                    <h5 className='mb-1 fw-bold'>Ubicación</h5>
                    <p className='mb-2'>
                      Bulevar Centro América, Edificio Corporativo C.A 5 Piso 3,
                      Tegucigalpa, Honduras
                    </p>

                    <div style={styles.mapContainer}>
                      <MapContainer
                        center={position}
                        zoom={15}
                        style={{ height: "100%", width: "100%" }}
                      >
                        <TileLayer
                          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                        <Marker position={position}>
                          <Popup>
                            MBox Honduras <br /> Edificio Corporativo C.A
                          </Popup>
                        </Marker>
                      </MapContainer>
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6}>
          <Card style={styles.card}>
            <div style={styles.cardHeader}>
              <h3 className='mb-0'>Contáctanos directamente</h3>
            </div>
            <Card.Body className='p-4 text-center'>
              <div className='mb-4'>
                <FaWhatsapp size={60} color='#25D366' />
                <h4 className='mt-3'>¿Tienes alguna pregunta?</h4>
                <p className='text-muted'>
                  Haz clic en el botón para contactarnos directamente por
                  WhatsApp
                </p>
              </div>

              <Button
                variant='success'
                size='lg'
                className='fw-bold'
                style={{
                  backgroundColor: "#25D366",
                  borderColor: "#25D366",
                  padding: "1rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  margin: "0 auto",
                }}
                onClick={handleContactoSubmit}
              >
                <FaWhatsapp size={24} />
                Chatear por WhatsApp
              </Button>

              <div className='mt-4 pt-3 border-top'>
                <p className='mb-2'>También puedes encontrarnos en:</p>
                <div className='d-flex justify-content-center gap-3'>
                  <a
                    href='https://www.facebook.com/mbox.express'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-decoration-none'
                  >
                    <Button
                      variant='outline-primary'
                      className='rounded-circle p-2'
                    >
                      <FaFacebook size={20} />
                    </Button>
                  </a>
                  <a
                    href='https://www.instagram.com/mbox.express/'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-decoration-none'
                  >
                    <Button
                      variant='outline-primary'
                      className='rounded-circle p-2'
                    >
                      <FaInstagram size={20} />
                    </Button>
                  </a>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );

  const renderFormulario = () => (
    <Card style={styles.card}>
      <div style={styles.cardHeader}>
        <div className='text-center'>
          <img
            src={logo}
            alt='MBox Logo'
            width={80}
            height={80}
            className='rounded-circle border border-3 border-white mb-2'
          />
          <h3 className='mb-0'>Crear Casillero</h3>
        </div>
      </div>
      <Card.Body className='p-4'>
        {showSuccess && (
          <Alert variant='success' className='text-center'>
            ¡Registro exitoso! En breve recibirás en tu correo electrónico el
            número de casillero asignado y las instrucciones para comenzar a
            recibir pedidos. Revisa también la carpeta de spam.
          </Alert>
        )}
        {showError && (
          <Alert variant='danger' className='text-center'>
            Por favor, verifica los campos e intenta nuevamente.
          </Alert>
        )}

        <Form noValidate onSubmit={handleSubmit}>
          <Form.Group className='mb-3'>
            <Form.Label className='fw-bold'>Nombre completo</Form.Label>
            <Form.Control
              type='text'
              name='nombre'
              minLength={3}
              maxLength={100}
              required
              value={formData.nombre}
              onChange={handleInputChange}
              className='py-2'
            />
            <Form.Control.Feedback type='invalid'>
              El nombre debe tener entre 3 y 100 caracteres
            </Form.Control.Feedback>
          </Form.Group>

          <Row className='mb-3'>
            {/* COLUMNA IDENTIDAD (SIN CAMBIOS) */}
            <Col md={6}>
              <Form.Group>
                <Form.Label className='fw-bold'>Identidad</Form.Label>
                <Form.Control
                  type='text'
                  name='identidad'
                  value={formData.identidad}
                  onChange={handleFormattedInputChange} // Usa la función original (para ####-####-#####)
                  placeholder='####-####-#####'
                  className='py-2'
                  maxLength={15} // 13 números + 2 guiones
                  isInvalid={!!errors.identidad}
                />
                {errors.identidad && (
                  <Form.Control.Feedback type='invalid' className='d-block'>
                    {errors.identidad}
                  </Form.Control.Feedback>
                )}
                {!errors.identidad && (
                  <>
                    <Form.Text muted>Ejemplo: 0801-1990-12345</Form.Text>
                    <br />
                    <Form.Text className='fst-italic text-primary'>
                      Nota: Los guiones se agregan automáticamente.
                    </Form.Text>
                  </>
                )}
              </Form.Group>
            </Col>

            {/* COLUMNA TELÉFONO (CON CAMBIOS) */}
            <Col md={6}>
              <Form.Group>
                <Form.Label className='fw-bold'>Teléfono</Form.Label>
                <Form.Control
                  type='tel'
                  name='telefono'
                  value={formData.telefono}
                  onChange={handlePhoneFormattedChange}
                  placeholder='Ej: 0001-0002 o 555-666-7777'
                  className='py-2'
                  maxLength={12}
                  isInvalid={!!errors.telefono}
                />
                {errors.telefono && (
                  <Form.Control.Feedback type='invalid' className='d-block'>
                    {errors.telefono}
                  </Form.Control.Feedback>
                )}
                {!errors.telefono && (
                  <>
                    <Form.Text muted>
                      Ejemplo: 00001-00002 o 555-666-7777
                    </Form.Text>
                    <br />
                    <Form.Text className='fst-italic text-primary'>
                      Nota: Los guiones se agregan automáticamente.
                    </Form.Text>
                  </>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-3'>
            <Col md={6}>
              <Form.Group>
                <Form.Label className='fw-bold'>Correo electrónico</Form.Label>
                <Form.Control
                  type='email'
                  name='email'
                  value={formData.email}
                  onChange={handleInputChange}
                  className='py-2'
                  isInvalid={!!errors.email}
                  placeholder='ejemplo@dominio.com'
                />
                {errors.email && (
                  <Form.Control.Feedback type='invalid' className='d-block'>
                    {errors.email}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className='fw-bold'>Fecha de nacimiento</Form.Label>
                <Form.Control
                  type='date'
                  name='fechaNacimiento'
                  required
                  value={formData.fechaNacimiento}
                  onChange={handleInputChange}
                  className='py-2'
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-3'>
            <Col md={6}>
              <Form.Group>
                <Form.Label className='fw-bold'>Tipo</Form.Label>
                <Form.Select
                  name='idTipoCliente'
                  value={formData.idTipoCliente}
                  onChange={handleInputChange}
                  required
                  className='py-2'
                >
                  {tiposClientes.map((tipo) => (
                    <option key={tipo.idTipoCliente} value={tipo.idTipoCliente}>
                      {tipo.nombreTipoCliente}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className='fw-bold'>Dirección</Form.Label>
                <Form.Control
                  type='text'
                  name='direccion'
                  value={formData.direccion}
                  onChange={handleInputChange}
                  minLength={5}
                  maxLength={255}
                  className='py-2'
                />
                <Form.Control.Feedback type='invalid'>
                  La dirección debe tener entre 5 y 255 caracteres
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className='mb-4 d-flex justify-content-center'>
            <div className='d-inline-block'>
              {" "}
              <Form.Check
                type='checkbox'
                required
                id='terminos'
                label={
                  <span>
                    He leído y acepto la{" "}
                    <a
                      href='/politicas-de-privacidad'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='text-primary fw-bold text-decoration-underline'
                    >
                      Política de Privacidad y Términos de Servicio
                    </a>
                  </span>
                }
                checked={formData.terminosAceptados || false}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    terminosAceptados: e.target.checked,
                  }))
                }
                feedback='Debes aceptar los términos para continuar'
                feedbackType='invalid'
              />
            </div>
          </Form.Group>

          <div className='text-center mt-4'>
            <Button
              variant='primary'
              type='submit'
              size='lg'
              className='px-5 fw-bold'
            >
              Registrar
            </Button>
          </div>

          <div className='text-center mt-4'>
            <p className='mb-3'>Síguenos en nuestras redes sociales</p>
            <div className='d-flex justify-content-center gap-3'>
              <a
                href='https://www.instagram.com/mbox.express/'
                target='_blank'
                rel='noopener noreferrer'
                className='text-decoration-none'
              >
                <Button
                  variant='outline-primary'
                  className='rounded-circle p-2'
                >
                  <FaInstagram size={20} />
                </Button>
              </a>
              <a
                href='https://www.facebook.com/mbox.express'
                target='_blank'
                rel='noopener noreferrer'
                className='text-decoration-none'
              >
                <Button
                  variant='outline-primary'
                  className='rounded-circle p-2'
                >
                  <FaFacebook size={20} />
                </Button>
              </a>
              <a
                href='https://wa.me/50498744314'
                target='_blank'
                rel='noopener noreferrer'
                className='text-decoration-none'
              >
                <Button
                  variant='outline-primary'
                  className='rounded-circle p-2'
                >
                  <FaWhatsapp size={20} />
                </Button>
              </a>
            </div>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );

  return (
    <div style={styles.background}>
      <Container>
        <Row className='justify-content-center mb-1'>
          <Col xs={12} className='text-center'>
            <h2
              className='text-white mb-2'
              style={{
                fontWeight: "700",
                textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
              }}
            >
              MBox Honduras
            </h2>
            <p className='lead text-light' style={{ fontWeight: "500" }}>
              Servicios de envíos y logística internacional
            </p>
          </Col>
        </Row>

        <Row className='justify-content-center mb-4'>
          <Col xs={12} className='d-flex justify-content-center'>
            <Nav variant='pills' style={styles.navPills}>
              <Nav.Item>
                <Nav.Link
                  eventKey='formulario'
                  active={activeSection === "formulario"}
                  onClick={() => setActiveSection("formulario")}
                  style={
                    activeSection === "formulario"
                      ? { ...styles.navLink, ...styles.navLinkActive }
                      : styles.navLink
                  }
                >
                  Crear Casillero
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey='calculadora'
                  active={activeSection === "calculadora"}
                  onClick={() => setActiveSection("calculadora")}
                  style={
                    activeSection === "calculadora"
                      ? { ...styles.navLink, ...styles.navLinkActive }
                      : styles.navLink
                  }
                >
                  Calculadora
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey='contacto'
                  active={activeSection === "contacto"}
                  onClick={() => setActiveSection("contacto")}
                  style={
                    activeSection === "contacto"
                      ? { ...styles.navLink, ...styles.navLinkActive }
                      : styles.navLink
                  }
                >
                  Contáctanos
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>

        <Row className='justify-content-center'>
          <Col xs={12}>
            {activeSection === "formulario" && renderFormulario()}
            {activeSection === "calculadora" && renderCalculadora()}
            {activeSection === "contacto" && renderContacto()}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FormularioCliente;
